import { addDays, endOfMonth, endOfWeek, startOfDay, startOfMonth, startOfWeek } from 'date-fns';
import { AGENDA_DAYS } from './AgendaView';

/**
 * The [from, to) instants the server is asked for, for a calendar position. One day of padding on
 * each side absorbs the difference between the browser's day boundaries and the provider's, so a
 * booking on the first or last visible date is never missed. `to` is exclusive.
 */
export function rangeFor(mode, date, locale) {
  let first;
  let lastInclusive;
  if (mode === 'month') {
    first = startOfWeek(startOfMonth(date), { locale });
    lastInclusive = endOfWeek(endOfMonth(date), { locale });
  } else if (mode === 'week') {
    first = startOfWeek(date, { locale });
    lastInclusive = endOfWeek(date, { locale });
  } else {
    first = startOfDay(date);
    lastInclusive = addDays(first, AGENDA_DAYS);
  }
  return { from: addDays(startOfDay(first), -1), to: addDays(startOfDay(lastInclusive), 2) };
}
